import { Text, Image } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { InviteCreativesActionFragmentDoc } from "@/gql/graphql"
import clsx from "clsx"
import Link from "next/link"
import InvitesIcon from "../../[id]/(jobOwnerPage)/icons/InvitesIcon"
import { ActionRow } from "./ActionRow"
import { PlusIcon } from "@heroicons/react/24/outline"
import { ampli } from "@/ampli"

graphql(`
  fragment InviteCreativesAction on JobPosting {
    id
    __typename
    invitationCount
  }
`)

export const InviteCreatives = ({
  jobPostingFragment,
  track,
}: {
  jobPostingFragment: FragmentType<typeof InviteCreativesActionFragmentDoc> | null | undefined
  track: (shortcutType: "suggestedCreatives") => void
}) => {
  const jobPosting = useFragment(InviteCreativesActionFragmentDoc, jobPostingFragment)
  const jobId = jobPosting?.id
  return (
    <div onClick={() => track("suggestedCreatives")}>
      <Link
        href={`/hire/${jobId}?tab=invites`}
        className="hidden w-full flex-row items-center justify-between px-6 py-[19px] md:flex">
        <div className="flex flex-col gap-y-[6px]">
          <Text variant="body1" className="text-fg-1">
            Invite suggested creatives
          </Text>
        </div>
        <div className="relative h-[52px] w-10">
          <div className="flex gap-x-2">
            {Array(2)
              .fill(0)
              .map((_, i) => (
                <div
                  key={i}
                  style={{
                    boxShadow: i === 1 ? "0px 0px 8px 0px rgba(0, 0, 0, 0.28)" : "",
                  }}
                  className={clsx(
                    "absolute z-0 flex h-[52px] w-10 items-center justify-center rounded-md border border-primary-2 bg-bg-3",
                    i === 1 && "z-0 rotate-[20deg]"
                  )}>
                  <PlusIcon className="size-4 stroke-primary-3" />
                </div>
              ))}
          </div>
        </div>
      </Link>
      <div className="md:hidden">
        <ActionRow
          icon={
            <div className="flex size-10 items-center justify-center rounded-sm bg-bg-2 md:size-6 md:bg-bg-1">
              <InvitesIcon width={24} height={24} className="stroke-fg-3" />
            </div>
          }
          text="Invites"
          count={jobPosting?.invitationCount}
          link={`/hire/${jobId}?tab=invites`}
        />
      </div>
    </div>
  )
}
